import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import SeoContent from './components/SeoContent';
import WhySpreadsheet from './components/WhySpreadsheet';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <WhySpreadsheet />
        <CategoryGrid />
        <SeoContent />
      </main>
      <Footer />
    </div>
  );
}